import React, { useEffect, useState } from "react";
import "../styles/InternationalPhoneInput.css";
import {
  PHONE_COUNTRIES,
  buildPhoneValue,
  getCountryByCode,
  getInitialPhoneParts,
  isMaskedPhone,
} from "../helpers/phoneHelper";

const InternationalPhoneInput = ({
  id,
  value = "",
  onChange,
  invalid = false,
  disabled = false,
  defaultCountryCode = "BR",
  placeholder,
}) => {
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [nationalNumber, setNationalNumber] = useState("");

  useEffect(() => {
    const nextParts = getInitialPhoneParts(
      value,
      countryCode || defaultCountryCode,
    );
    setCountryCode(nextParts.countryCode);
    setNationalNumber(nextParts.nationalNumber);
  }, [value, defaultCountryCode, countryCode]);

  const currentCountry = getCountryByCode(countryCode);
  const hasMaskedValue = isMaskedPhone(value);

  const handleCountryChange = (event) => {
    const nextCountryCode = event.target.value;
    setCountryCode(nextCountryCode);
    onChange(buildPhoneValue(nextCountryCode, nationalNumber));
  };

  const handleNumberChange = (event) => {
    if (hasMaskedValue) return;

    const digits = event.target.value.replace(/\D/g, "");
    setNationalNumber(digits);
    onChange(buildPhoneValue(countryCode, digits));
  };

  const handleNumberFocus = () => {
    if (!hasMaskedValue) return;

    setNationalNumber("");
    onChange("");
  };

  return (
    <div className={`international-phone-input ${invalid ? "is-invalid" : ""} ${disabled ? "is-disabled" : ""}`}>
      <select
        className="portal-select international-phone-country"
        value={countryCode}
        onChange={handleCountryChange}
        disabled={disabled || hasMaskedValue}
        aria-label="Select country code"
      >
        {PHONE_COUNTRIES.map((country) => (
          <option key={country.code} value={country.code}>
            {country.flag} {country.dialCode} {country.name}
          </option>
        ))}
      </select>
      <input
        id={id}
        type="tel"
        className="portal-input international-phone-number"
        value={nationalNumber}
        onChange={handleNumberChange}
        onFocus={handleNumberFocus}
        disabled={disabled}
        aria-invalid={invalid}
        inputMode="numeric"
        autoComplete="tel"
        placeholder={placeholder || currentCountry.example}
      />
    </div>
  );
};

export default InternationalPhoneInput;
